import {createSlice} from '@reduxjs/toolkit';
import {toast} from 'react-toastify';
import {LimitTypesIds} from '../../utils/constants';

const initialState = {
  isLoading: false,
  riskAssessmentTasks: [],
  task_event_mapping: [],
  machineLimits: {},
  assumptions: {},
  revisionHistory: [],
  attendance: [],
  employee: [],
  summary: [],
  task_detail: {},
  riskAssessmentInfo: {
    filterCriteria: {},
  },
  subCategoriesData: [],
  position: 0,
  attendanceByDateData: [],
  actionItems: [],
  userListData: [],
  riskAssessmentInfo: {
    filterCriteria: {},
  },
  subCategoriesData: [],
  position: 0,
  attendanceByDateData: [],
  actionItems: [],
  userListData: [],
  failureModeData: [],
  devices: [],
  device: {},
  scoringReference: null,
};

const riskAssessmentCoreSlice = createSlice({
  name: 'riskAssessmentCore',
  initialState,
  reducers: {
    //update filters
    updateFilterCriteria: (state, action) => {
      state.riskAssessmentInfo = {
        ...state.riskAssessmentInfo,
        filterCriteria: action.payload,
      };
    },
    // get Risk Assessments Tasks
    getRiskAssessmentTasks: state => {
      state.isLoading = true;
    },
    getRiskAssessmentTasksSuccess: (state, action) => {
      const response = action.payload;
      state.riskAssessmentTasks = response;
      state.isLoading = false;
    },
    getRiskAssessmentTasksFailure: state => {
      state.isLoading = false;
      state.riskAssessmentTasks = [];
    },

    // get Risk Assessments Task detail
    getTaskDetail: state => {
      state.isLoading = true;
    },
    taskDetailSuccess: (state, action) => {
      state.isLoading = false;
      const taskDetail = action.payload;
      const myMap = new Map();
      taskDetail.task_event_mapping.forEach(el => {
        if (!myMap.get(el.event)) {
          myMap.set(el.event, [el]);
        } else {
          myMap.set(el.event, [...myMap.get(el.event), el]);
        }
      });
      state.task_event_mapping = myMap;
      state.task_detail = taskDetail;
    },
    taskDetailFailure: state => {
      state.isLoading = false;
    },
    // create Risk Assessments Task
    createTask: state => {
      state.isLoading = true;
    },
    createTaskSuccess: state => {
      state.isLoading = false;
    },
    createTaskFailure: state => {
      state.isLoading = false;
    },

    // update Risk Assessments Task
    updateTask: state => {
      state.isLoading = true;
    },
    updateTaskSuccess: (state, action) => {
      state.isLoading = false;
      const taskDetail = action.payload;
      const myMap = new Map();
      taskDetail.task_event_mapping.forEach(el => {
        if (!myMap.get(el.event)) {
          myMap.set(el.event, [el]);
        } else {
          myMap.set(el.event, [...myMap.get(el.event), el]);
        }
      });
      state.task_event_mapping = myMap;
      state.task_detail = taskDetail;

      toast.success('Task updated successfully!' , {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    updateTaskFailure: state => {
      state.isLoading = false;
      toast.error('Task update failed. Please try again.' , {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },
    // update Risk Assessments Task Media
    updateTaskMedia: state => {
      state.isLoading = true;
    },
    updateTaskMediaSuccess: state => {
      state.isLoading = false;
      toast.success('Media Uploaded Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    updateTaskMediaFailure: state => {
      state.isLoading = false;
    },

    //Delete Risk Assessments Task Media
    deleteTaskMedia: state => {
      state.isLoading = true;
    },
    deleteTaskMediaSuccess: state => {
      state.isLoading = false;
      toast.success('Media Deleted Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    deleteTaskMediaFailure: state => {
      state.isLoading = false;
    },

    // Delete a Risk Assessments Task
    deleteTask: state => {
      state.isLoading = true;
    },
    deleteTaskSuccess: state => {
      state.isLoading = false;
      toast.success('Task Deleted Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    deleteTaskFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },

    // Mark no to event
    markNoExpToUnWantedEvents: state => {
      state.isLoading = true;
    },
    markNoExpToUnWantedEventsSuccess: state => {
      state.isLoading = false;
    },
    markNoExpToUnWantedEventsFailure: state => {
      state.isLoading = false;
    },

    // Add sub category to events
    addSubCategoryEvents: state => {
      state.isLoading = true;
    },
    addSubCategoryEventsSuccess: state => {
      state.isLoading = false;
    },
    addSubCategoryEventsFailure: state => {
      state.isLoading = false;
    },

    // Delete a sub category from event
    deleteSubCategoryEvents: state => {
      state.isLoading = true;
    },
    deleteSubCategoryEventsSuccess: state => {
      state.isLoading = false;
    },
    deleteSubCategoryEventsFailure: state => {
      state.isLoading = false;
    },

    // get machine limits data
    getMachineLimits: state => {
      state.isLoading = true;
    },
    getMachineLimitsSuccess: (state, action) => {
      const updated = {...state.machineLimits};
      updated[action.payload.raId] = action.payload.data;
      const obj = {
        space: [],
        time: [],
        use: [],
        other: [],
      };
      action.payload.data.forEach(el => {
        if (el.type === LimitTypesIds['SPACE']) {
          obj.space.push(el);
        } else if (el.type === LimitTypesIds['TIME']) {
          obj.time.push(el);
        } else if (el.type === LimitTypesIds['USE']) {
          obj.use.push(el);
        } else if (el.type === LimitTypesIds['OTHER']) {
          obj.other.push(el);
        }
      });
      state.machineLimits = obj;
      state.isLoading = false;
    },
    getMachineLimitsFailure: state => {
      state.isLoading = false;
    },

    // add machine limits data
    addMachineLimits: state => {
      state.isLoading = true;
    },
    addMachineLimitsSuccess: (state, action) => {
      state.isLoading = false;
    },
    addMachineLimitsFailure: state => {
      state.isLoading = false;
    },
    //save event detail
    saveEventDetail: state => {
      state.isLoading = true;
    },
    saveEventDetailSuccess: state => {
      state.isLoading = false;
    },
    saveEventDetailFailure: state => {
      state.isLoading = false;
    },

    //
    getEventDetail: state => {
      state.isLoading = true;
    },
    eventDetailSuccess: (state, action) => {
      // const response = action.payload
      // state.eventDetail = response
      state.isLoading = false;
    },
    eventDetailFailure: state => {
      state.isLoading = false;
    },

    //update event detail
    updateEventDetail: state => {
      state.isLoading = true;
    },
    updateEventDetailSuccess: state => {
      state.isLoading = false;
    },
    updateEventDetailFailure: state => {
      state.isLoading = false;
    },

    //upload Media
    uploadMedia: state => {
      state.isLoading = true;
    },
    uploadMediaSuccess: state => {
      state.isLoading = false;
      toast.success('Media Uploaded Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    uploadMediaFailure: state => {
      state.isLoading = false;
    },

    // get Assumption
    getAssumptions: state => {
      state.isLoading = true;
    },
    getAssumptionSuccess: (state, action) => {
      state.isLoading = false;
      state.assumptions = action.payload.data;
    },
    getAssumptionFailure: state => {
      state.isLoading = false;
    },

    // add Assumption
    addAssumption: state => {
      state.isLoading = true;
    },
    addAssumptionSuccess: (state, action) => {
      state.isLoading = false;
    },
    addAssumptionFailure: state => {
      state.isLoading = false;
    },

    // get RevisionHistory
    getRevisionHistory: state => {
      state.isLoading = true;
    },
    getRevisionHistorySuccess: (state, action) => {
      state.isLoading = false;
      state.revisionHistory = action.payload.data;
    },
    getRevisionHistoryFailure: state => {
      state.isLoading = false;
    },

    // add RevisionHistory
    addRevisionHistory: state => {
      state.isLoading = true;
    },
    addRevisionHistorySuccess: (state, action) => {
      state.isLoading = false;
    },
    addRevisionHistoryFailure: state => {
      state.isLoading = false;
    },

    // get attendance
    getAttendance: state => {
      state.isLoading = true;
    },
    getNewAttendance: state => {
      state.isLoading = true;
    },
    getAttendanceSuccess: (state, action) => {
      state.isLoading = false;
      state.attendance = action.payload.data;
    },
    getAssumptionFailure: state => {
      state.isLoading = false;
    },

    // add attendance
    addAttendance: state => {
      state.isLoading = true;
    },
    addAttendanceSuccess: (state, action) => {
      state.isLoading = false;
      toast.success('Attendance added Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    addAttendanceFailure: state => {
      state.isLoading = false;
    },

    // get Employee
    getEmployee: state => {
      state.isLoading = true;
    },
    getEmployeeSuccess: (state, action) => {
      state.isLoading = false;
      state.employee = action.payload.data;
    },
    getEmployeeFailure: state => {
      state.isLoading = false;
    },

    // get Summary
    getSummary: state => {
      state.isLoading = true;
    },
    getSummarySuccess: (state, action) => {
      state.isLoading = false;
      state.summary = action.payload;
    },
    getSummaryFailure: state => {
      state.isLoading = false;
    },
    //generate Excel Id
    generateExcelId: state => {
      // state.isLoading = true
    },
    generateExcelIdSuccess: (state, action) => {
      state.isLoading = false;
      // state.excelStatus = action.payload
    },
    generateExcelIdFailure: state => {
      state.isLoading = false;
    },

    //generate Excel
    generateExcel: state => {
      // state.isLoading = true
    },

    generateExcelSuccess: (state, action) => {
      state.isLoading = false;
      // state.excelDetails = action.payload
    },

    generateExcelFailure: (state, action) => {
      state.isLoading = false;
    },
    // Import Risk Assessment
    importRiskAssessment: state => {
      state.isLoading = true;
    },
    importRiskAssessmentSuccess: (state, action) => {
      state.isLoading = false;
      toast.success(action.payload.message || 'Risk Assessment imported successfully', {autoClose: 3000});
    },
    importRiskAssessmentFailure: (state, action) => {
      state.isLoading = false;
      toast.error(action.payload?.error || 'Failed to import Risk Assessment', {autoClose: 3000});
    },

    //import-event
    importEvent: state => {
      state.isLoading = true;
    },

    importEventSuccess: state => {
      state.isLoading = false;
      toast.success('Imported Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },

    importEventFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },

    deleteNotes: state => {
      state.isLoading = true;
    },
    deleteNoteSuccess: state => {
      state.isLoading = false;
      toast.success('Note Deleted Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    deleteNoteFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(
        response.message || 'Something went wrong. Please try again!',
        {
          autoClose: 2000,
          className: 'toast-error',
        },
      );
    },

    // get RevisionHistory
    getSubCategoriesForEventsBasedOnId: state => {
      state.isLoading = true;
    },
    getSubCategoriesForEventsBasedOnIdSuccess: (state, action) => {
      state.isLoading = false;
      state.subCategoriesData = action.payload.data;
    },
    getSubCategoriesForEventsBasedOnIdFailure: state => {
      state.isLoading = false;
    },
    setScrollPosition: (state, action) => {
      state.position = action.payload;
    },

    // Delete a Attendance Record
    deleteAttendance: state => {
      state.isLoading = true;
    },
    deleteAttendanceSuccess: state => {
      state.isLoading = false;
      toast.success('Attendance Record Deleted Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    deleteAttendanceFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },

    // Attendance By date
    attendanceByDate: state => {
      state.isLoading = true;
    },
    getAttendanceByDateSuccess: (state, action) => {
      state.isLoading = false;
      if (action?.payload?.data?.message) {
        state.attendanceByDateData = [];
        toast.error(action.payload.data.message, {
          autoClose: 2000,
          className: 'toast-fail',
        });
      } else {
        state.attendanceByDateData = action.payload.data ?? [];
      }
    },
    getAttendanceByDateFailure: state => {
      state.isLoading = false;
    },

    clearAttendanceByDateData: state => {
      state.attendanceByDateData = [];
    },

    //save attendance session
    saveSessionForAttendance: state => {
      state.isLoading = true;
    },
    saveSessionForAttendanceSuccess: (state, action) => {
      state.isLoading = false;
      const response = action.payload;
      const message = response?.data?.message ?? 'Session saved successfully.';
      toast.success(message, {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    saveSessionForAttendanceFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },

    //post action session
    postActionItemData: state => {
      state.isLoading = true;
    },
    postActionItemDataSuccess: state => {
      state.isLoading = false;
    },
    postActionItemDataFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },

    //getlist action session

    getActionItemData: state => {
      state.isLoading = true;
    },
    getActionItemDataSuccess: (state, action) => {
      state.isLoading = false;
      state.actionItems = action.payload.data;
    },
    getActionItemDataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    //patch action item
    updateActionItemData: state => {
      state.isLoading = true;
    },
    updateActionItemDataSuccess: state => {
      state.isLoading = false;
    },
    updateActionItemDataFailure: state => {
      state.isLoading = false;
    },

    // Delete action items
    deleteActionItems: state => {
      state.isLoading = true;
    },
    deleteActionItemsSuccess: (state, action) => {
      state.isLoading = false;
      // state.actionItems = state.actionItems.filter(
      //   item => item.id !== action.payload.id,
      // );
      toast.success('Action item Deleted Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    deleteActionItemsFailure: state => {
      state.isLoading = false;
    },

    // get userlist data

    getUserList: state => {
      state.isLoading = true;
    },
    getUserListSuccess: (state, action) => {
      state.isLoading = false;
      state.userListData = action.payload.data;
    },
    getUserListFailure: state => {
      state.isLoading = false;
    },

    editAttendance: state => {
      state.isLoading = true;
    },
    editAttendanceSuccess: state => {
      state.isLoading = false;
      toast.success('Attendance Record Updated Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    editAttendanceFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },
    
    // get RevisionHistory
    getSubCategoriesForEventsBasedOnId: state => {
      state.isLoading = true;
    },
    getSubCategoriesForEventsBasedOnIdSuccess: (state, action) => {
      state.isLoading = false;
      state.subCategoriesData = action.payload.data;
    },
    getSubCategoriesForEventsBasedOnIdFailure: state => {
      state.isLoading = false;
    },
    getFailureModeData: (state, action) => {
      if (!action.payload?.skipLoading) {
        state.isLoading = true;
      }
    },
    getFailureModeDataSuccess: (state, action) => {
      state.isLoading = false;
      state.failureModeData = action.payload.data;
    },
    getFailureModeDataFailure: state => {
      state.isLoading = false;
    },
    //bulk add failure mode data
    bulkAddFailureModeData: state => {
      // state.isLoading = true;
    },
    bulkAddFailureModeDataSuccess: state => {
      // state.isLoading = false;
    },
    bulkAddFailureModeDataFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },
    //bulk update failure mode data
    bulkUpdateFailureModeData: state => {
      // state.isLoading = true;
    },
    bulkUpdateFailureModeDataSuccess: state => {
      // state.isLoading = false;
    },
    bulkUpdateFailureModeDataFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },
    setScrollPosition: (state, action) => {
      state.position = action.payload;
    },

    // Delete a Attendance Record
    deleteAttendance: state => {
      state.isLoading = true;
    },
    deleteAttendanceSuccess: state => {
      state.isLoading = false;
      toast.success('Attendance Record Deleted Successfully', {
        autoClose: 2000,
        className: 'toast-success',
      });
    },
    deleteAttendanceFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },

    // Attendance By date
    attendanceByDate: state => {
      state.isLoading = true;
    },
    getAttendanceByDateSuccess: (state, action) => {
      state.isLoading = false;
      if (action?.payload?.data?.message) {
        state.attendanceByDateData = [];
        toast.error(action.payload.data.message, {
          autoClose: 2000,
          className: 'toast-fail',
        });
      } else {
        state.attendanceByDateData = action.payload.data ?? [];
      }
    },
    getAttendanceByDateFailure: state => {
      state.isLoading = false;
    },

    clearAttendanceByDateData: state => {
      state.attendanceByDateData = [];
    },

    //save attendance session
    saveSessionForAttendance : state => {
      state.isLoading = true
    },
    saveSessionForAttendanceSuccess: state => {
      state.isLoading = false;
    },
    saveSessionForAttendanceFailure: (state, action) => {
      const response = action.payload;
      state.isLoading = false;
      toast.error(response.message, {
        autoClose: 2000,
        className: 'toast-fail',
      });
    },

  //post action session
  postActionItemData : state => {
    state.isLoading = true
  },
  postActionItemDataSuccess: state => {
    state.isLoading = false;
  },
  postActionItemDataFailure: (state, action) => {
    const response = action.payload;
    state.isLoading = false;
    toast.error(response.message, {
      autoClose: 2000,
      className: 'toast-fail',
    });
  }, 

  //getlist action session

  getActionItemData: state => {
    state.isLoading = true;
  },
  getActionItemDataSuccess: (state, action) => {
    state.isLoading = false;
    state.actionItems = action.payload.data; 
    
  },
  getActionItemDataFailure: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },

  //patch action item
  updateActionItemData: state => {
    state.isLoading = true;
  },
  updateActionItemDataSuccess: state => {
    state.isLoading = false;
  },
  updateActionItemDataFailure: state => {
    state.isLoading = false;
  },

  // Delete action items
  deleteActionItems: state => {
    state.isLoading = true;
  },
  deleteActionItemsSuccess: state => {
    state.isLoading = false;
    toast.success('Attendance Record Deleted Successfully', {
      autoClose: 2000,
      className: 'toast-success',
    });
  },
  deleteActionItemsFailure: state => {
    state.isLoading = false;
  },
  

  // get userlist data 

  getUserList: state => {
    state.isLoading = true;
  },
  getUserListSuccess: (state, action) => {
    state.isLoading = false;
    state.userListData = action.payload.data;
  },
  getUserListFailure: state => {
    state.isLoading = false;
  },

  // Add event to task
  addEventToTask: state => {
    state.isLoading = true;
  },
  addEventToTaskSuccess: (state, action) => {
    state.isLoading = false;
    toast.success('Event added successfully', {
      autoClose: 2000,
      className: 'toast-success',
    });
  },
  addEventToTaskFailure: (state, action) => {
    state.isLoading = false;
    let errorMessage = 'Failed to add event';
    if (action.payload?.message && action.payload.message.trim()) {
      errorMessage = action.payload.message;
    } else if (typeof action.payload === 'string' && action.payload.trim()) {
      errorMessage = action.payload;
    }
    toast.error(errorMessage, {
      autoClose: 2000,
      className: 'toast-error',
    });
  },

  // Update event for task
  updateEventForTask: state => {
    state.isLoading = true;
  },
  updateEventForTaskSuccess: (state, action) => {
    state.isLoading = false;
    toast.success('Event updated successfully', {
      autoClose: 2000,
      className: 'toast-success',
    });
  },
  updateEventForTaskFailure: (state, action) => {
    state.isLoading = false;
    let errorMessage = 'Failed to update event';
    if (action.payload?.message && action.payload.message.trim()) {
      errorMessage = action.payload.message;
    } else if (typeof action.payload === 'string' && action.payload.trim()) {
      errorMessage = action.payload;
    }
    toast.error(errorMessage, {
      autoClose: 2000,
      className: 'toast-error',
    });
  },

  // Cybersecurity devices
  getDevices: state => {
    state.isLoading = true;
  },
  getDevicesSuccess: (state, action) => {
    state.isLoading = false;
    state.devices = Array.isArray(action.payload) ? action.payload : [];
  },
  getDevicesFailure: (state, action) => {
    state.isLoading = false;
    toast.error(action.payload.message, {
      autoClose: 2000,
      className: 'toast-fail',
    });
  },

  getDevice: state => {
    state.isLoading = true;
  },
  getDeviceSuccess: (state, action) => {
    state.isLoading = false;
    state.device = action.payload;
  },
  getDeviceFailure: (state, action) => {
    state.isLoading = false;
    toast.error(action.payload.message, {
      autoClose: 2000,
      className: 'toast-fail',
    });
  },

  createDevice: state => {
    state.isLoading = true;
  },
  createDeviceSuccess: (state, action) => {
    state.isLoading = false;
    state.device = action.payload;
  },
  createDeviceFailure: (state, action) => {
    state.isLoading = false;
    toast.error(action.payload.message, {
      autoClose: 2000,
      className: 'toast-fail',
    });
  },

  saveDevice: state => {
    state.isLoading = true;
  },
  saveDeviceSuccess: (state, action) => {
    state.isLoading = false;
    state.device = action.payload;
    toast.success('Successfully saved', {
      autoClose: 2000,
      className: 'toast-success',
    });
  },
  saveDeviceFailure: (state, action) => {
    state.isLoading = false;
    toast.error(action.payload.message, {
      autoClose: 2000,
      className: 'toast-fail',
    });
  },

  deleteDevice: state => {
    state.isLoading = true;
  },
  deleteDeviceSuccess: state => {
    state.isLoading = false;
    toast.success('Device deleted successfully', {
      autoClose: 2000,
      className: 'toast-success',
    });
  },
  deleteDeviceFailure: (state, action) => {
    state.isLoading = false;
    toast.error(action.payload.message, {
      autoClose: 2000,
      className: 'toast-fail',
    });
  },

  getScoringReference: state => {
    state.isLoading = true;
  },
  getScoringReferenceSuccess: (state, action) => {
    state.isLoading = false;
    state.scoringReference = action.payload;
  },
  getScoringReferenceFailure: (state, action) => {
    state.isLoading = false;
    toast.error(action.payload.message, {
      autoClose: 2000,
      className: 'toast-fail',
    });
  },
  },
});

export default riskAssessmentCoreSlice.reducer;
export const {
  updateFilterCriteria,
  // get product lines
  getRiskAssessmentTasks,
  getRiskAssessmentTasksSuccess,
  getRiskAssessmentTasksFailure,
  //task detail,
  getTaskDetail,
  taskDetailSuccess,
  taskDetailFailure,
  // create task
  createTask,
  createTaskSuccess,
  createTaskFailure,
  // update task
  updateTask,
  updateTaskSuccess,
  updateTaskFailure,
  // delete task
  deleteTask,
  deleteTaskSuccess,
  deleteTaskFailure,
  // update  task media
  updateTaskMedia,
  updateTaskMediaSuccess,
  updateTaskMediaFailure,
  //delete task media
  deleteTaskMedia,
  deleteTaskMediaSuccess,
  deleteTaskMediaFailure,
  // 'No' exposure to events
  markNoExpToUnWantedEvents,
  markNoExpToUnWantedEventsSuccess,
  markNoExpToUnWantedEventsFailure,
  // Add subcategory to an event
  addSubCategoryEvents,
  addSubCategoryEventsSuccess,
  addSubCategoryEventsFailure,
  // Delete subcategory from an event
  deleteSubCategoryEvents,
  deleteSubCategoryEventsSuccess,
  deleteSubCategoryEventsFailure,
  //  Get Machine limits Data
  getMachineLimits,
  getMachineLimitsSuccess,
  getMachineLimitsFailure,
  //  Add Machine limits Data
  addMachineLimits,
  addMachineLimitsSuccess,
  addMachineLimitsFailure,

  // save event detail
  saveEventDetail,
  saveEventDetailSuccess,
  saveEventDetailFailure,
  // event detail
  getEventDetail,
  eventDetailSuccess,
  eventDetailFailure,
  // update event detail
  updateEventDetail,
  updateEventDetailSuccess,
  updateEventDetailFailure,
  // upload media
  uploadMedia,
  uploadMediaSuccess,
  uploadMediaFailure,

  //  Get assumptions Data
  getAssumptions,
  getAssumptionSuccess,
  getAssumptionFailure,
  //  Add assumption Data
  addAssumption,
  addAssumptionSuccess,
  addAssumptionFailure,

  //  Get Revision History
  getRevisionHistory,
  getRevisionHistorySuccess,
  getRevisionHistoryFailure,
  //  Add RevisionHistory
  addRevisionHistory,
  addRevisionHistorySuccess,
  addRevisionHistoryFailure,

  //  Get Attendance
  getAttendance,
  getAttendanceSuccess,
  getAttendanceFailure,
  getNewAttendance,
  //  Add Attendance
  addAttendance,
  addAttendanceSuccess,
  addAttendanceFailure,
  //  Get Employee
  getEmployee,
  getEmployeeSuccess,
  getEmployeeFailure,
  //Summary
  getSummary,
  getSummarySuccess,
  getSummaryFailure,

  //generate Excel Id
  generateExcelId,
  generateExcelIdSuccess,
  generateExcelIdFailure,

  //generate Excel
  generateExcel,
  generateExcelSuccess,
  generateExcelFailure,
  importRiskAssessment,
  importRiskAssessmentSuccess,
  importRiskAssessmentFailure,

  //import Event
  importEvent,
  importEventSuccess,
  importEventFailure,



  

  // scroll position
  setScrollPosition,

  //delete attendance record
  deleteAttendance,
  deleteAttendanceSuccess,
  deleteAttendanceFailure,

  // attendance by date list
  attendanceByDate,
  getAttendanceByDateSuccess,
  getAttendanceByDateFailure,
  clearAttendanceByDateData,

  //save session for attendance
  saveSessionForAttendance,
  saveSessionForAttendanceSuccess,
  saveSessionForAttendanceFailure,

  //action item
  postActionItemData,
  postActionItemDataSuccess,
  postActionItemDataFailure,

  //get action list
  getActionItemData,
  getActionItemDataSuccess,
  getActionItemDataFailure,

  //update action items
  updateActionItemData,
  updateActionItemDataSuccess,
  updateActionItemDataFailure,

  //delete action items
  deleteActionItems,
  deleteActionItemsSuccess,
  deleteActionItemsFailure,

  // get user list data
  getUserList,
  getUserListSuccess,
  getUserListFailure,

  // for updating attendance
  editAttendance,
  editAttendanceFailure,
  editAttendanceSuccess,

  //clear-notes
  deleteNotes,
  deleteNoteSuccess,
  deleteNoteFailure,

  //sub categories based on id
  getSubCategoriesForEventsBasedOnId,
  getSubCategoriesForEventsBasedOnIdSuccess,
  getSubCategoriesForEventsBasedOnIdFailure,

  //get failure mode data
  getFailureModeData,
  getFailureModeDataSuccess,
  getFailureModeDataFailure,

  //bulk add failure mode data
  bulkAddFailureModeData,
  bulkAddFailureModeDataSuccess,
  bulkAddFailureModeDataFailure,

  //bulk update failure mode data
  bulkUpdateFailureModeData,
  bulkUpdateFailureModeDataSuccess,
  bulkUpdateFailureModeDataFailure,

  // Add event to task
  addEventToTask,
  addEventToTaskSuccess,
  addEventToTaskFailure,

  // Update event for task
  updateEventForTask,
  updateEventForTaskSuccess,
  updateEventForTaskFailure,

  // Cybersecurity devices
  getDevices,
  getDevicesSuccess,
  getDevicesFailure,
  getDevice,
  getDeviceSuccess,
  getDeviceFailure,
  createDevice,
  createDeviceSuccess,
  createDeviceFailure,
  saveDevice,
  saveDeviceSuccess,
  saveDeviceFailure,
  deleteDevice,
  deleteDeviceSuccess,
  deleteDeviceFailure,
  getScoringReference,
  getScoringReferenceSuccess,
  getScoringReferenceFailure,

} = riskAssessmentCoreSlice.actions;
